<template>
    <v-card class="pt-lg-5 pa-0" :height="screenHeight">
        <v-card-text
            :style="titleStyle">Calling
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text
            class="callingNo"
            :style="callingStyle"
        >
          {{ callingNo.no }}<template v-if="callingNo.counter"> - </template><span v-if="callingNo.counter" style="font-size: 48px;">{{ callingNo.counter }}</span>
        </v-card-text>
        <v-spacer></v-spacer>
        <v-list
        >
            <v-list-item
                v-for="(previousNo,i) in previousNos.slice().reverse()"
                :key="i"
                style="border-top: 1px solid #e2e2e2"
            >
                <v-list-item-content>
                    <v-list-item-title :style="listStyle">{{ previousNo.no }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        <div v-if="previousNo.counter" style="text-align: center;font-size: 25px"> {{
                                previousNo.counter
                            }}
                        </div>
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-card>
</template>

<script>
export default {
    data: () => {
        return {
            previousNos: [],
            callingNo: [],
        };
    },
    props: ['outlet', 'fulldisplay', 'fontSize'],
    computed: {
        titleStyle() {
            return {
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: this.fontSize ? this.fontSize : '40px',
                color: 'black',
            }
        },
        titleStyle2() {
            return {
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: '60px',
                color: 'black',
            }
        },
        callingStyle() {
            return {
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: '70px',
                color: 'red',
                lineHeight: '40px'
            }
        },
        callingStyle2() {
            return {
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: '70px',
                color: 'red',
                lineHeight: '60px'
            }
        },
        listStyle() {
            return {
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: '40px',
                color: 'black',
            }
        },
        listStyle2() {
            return {
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: '60px',
                color: 'black',
            }
        },
        screenHeight() {
          return 'calc(60vh - 88px)';
        }
    },
    methods: {
        playSound() {
            let bell = this.outlet.audio ? new Audio('/storage' + this.outlet.audio) : new Audio('/storage/audios/default.mp3');
            bell.play();
        },
    },
    created: function () {
      console.log(this.fulldisplay)
      console.log(this.fulldisplay)
      console.log(this.fulldisplay)
      console.log(this.fulldisplay)
      console.log(this.fulldisplay)
      console.log(this.fulldisplay)
      console.log(this.fulldisplay)
      console.log(this.fulldisplay)
        Echo.channel('tvcall-channel')
            .listen('.QueueNumberReceived', (e) => {
                console.log(e);
                if (e.outlet_id === this.outlet.id && e.type === 'queue') {
                    this.callingNo = {no: e.queue_number, counter: e.counter_no};
                    this.playSound();
                    // make queue # blinks
                    $('.callingNo').each(function () {
                        var elem = $(this);
                        // count the blinks
                        var count = 1;
                        var intervalId = setInterval(function () {
                            if (elem.css('visibility') == 'hidden') {
                                elem.css('visibility', 'visible');
                                // increment counter when showing to count # of blinks and stop when visible
                                if (count++ === 4) {
                                    clearInterval(intervalId);
                                }
                            } else {
                                elem.css('visibility', 'hidden');
                            }
                        }, 400);
                    });
                }
            })
    },
    watch: {
        callingNo: function (newVal, oldVal) {
            if (oldVal.length !== 0) {
                this.previousNos.push(oldVal);
            }
            if (this.previousNos.length === 5) {
                this.previousNos.shift();
            }
        },
    }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/VerticalCallingNumber.vue